import { render, staticRenderFns } from "./X-chantier-card.vue?vue&type=template&id=5721e009&scoped=true"
import script from "./X-chantier-card.vue?vue&type=script&lang=js"
export * from "./X-chantier-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5721e009",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5721e009')) {
      api.createRecord('5721e009', component.options)
    } else {
      api.reload('5721e009', component.options)
    }
    module.hot.accept("./X-chantier-card.vue?vue&type=template&id=5721e009&scoped=true", function () {
      api.rerender('5721e009', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chantier/X-chantier-card.vue"
export default component.exports